import { createProvider } from '@/vue-apollo'

import switchUserRoleMutation from '@/graphql/mutations/switchUserRole.gql'

const apolloClient = createProvider().defaultClient
const loadingStateKey = 'user'

const state = {
  all: []
}

const actions = {
  switchRole: async ({ commit }, roleId) => {
    commit('setLoadingState', { key: loadingStateKey, isLoading: true }, { root: true })
    await apolloClient.mutate({ mutation: switchUserRoleMutation, variables: { roleId }, fetchPolicy: 'no-cache' })
    commit('setLoadingState', { key: loadingStateKey, isLoading: false }, { root: true })
  }
}

const mutations = {
  //
}

const getters = {
  //
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
